const extractId = (id): string => id.split('-').pop()
export default extractId
